import { Link } from 'react-router-dom';

const FEATURED_CITY = {
  name: 'Indianapolis',
  county: 'Marion County',
  pop: '880,000+',
  href: '/life-insurance-indianapolis',
  tagline: "Indiana's capital city — serving Marion County families, Eli Lilly employees & IUPUI staff with personalized life insurance from $18/mo.",
  img: 'https://public.readdy.ai/ai/img_res/f6a542ceb1438e932758ace0a21be10f.jpg',
  badge: 'State Capital · Largest Market',
  icon: 'ri-building-4-fill',
};

const CITIES = [
  {
    name: 'Fort Wayne',
    county: "Allen County",
    pop: '270,000+',
    href: '/life-insurance-fort-wayne',
    tagline: "Indiana's second-largest city — competitive rates for northeast Indiana families.",
    img: 'https://readdy.ai/api/search-image?query=Fort%20Wayne%20Indiana%20downtown%20cityscape%20warm%20afternoon%20light%20suburban%20midwestern%20city%20architecture%20clean%20sky%20professional%20photography%20rich%20earth%20tones%20amber%20and%20cream%20buildings%20modern%20and%20classic%20architecture%20blend%20peaceful%20neighborhood%20feel&width=540&height=320&seq=ftwayne-hub-v1&orientation=landscape',
    icon: 'ri-building-2-line',
  },
  {
    name: 'South Bend',
    county: 'St. Joseph County',
    pop: '102,000+',
    href: '/life-insurance-south-bend',
    tagline: 'Home of Notre Dame — term life & final expense specialists for St. Joseph County.',
    img: 'https://readdy.ai/api/search-image?query=South%20Bend%20Indiana%20city%20street%20with%20university%20campus%20feel%20warm%20sunlight%20through%20mature%20trees%20lining%20brick%20sidewalks%20autumn%20colors%20midwestern%20charm%20professional%20photography%20golden%20warm%20tones%20peaceful%20college%20town%20atmosphere%20clean%20cream%20buildings&width=540&height=320&seq=southbend-hub-v1&orientation=landscape',
    icon: 'ri-community-line',
  },
  {
    name: 'Evansville',
    county: 'Vanderburgh County',
    pop: '117,000+',
    href: '/life-insurance-evansville',
    tagline: 'Southwest Indiana hub — whole life, IUL & annuity specialists for the Tri-State area.',
    img: 'https://readdy.ai/api/search-image?query=Evansville%20Indiana%20Ohio%20River%20waterfront%20city%20view%20golden%20hour%20light%20warm%20amber%20tones%20historic%20downtown%20buildings%20river%20reflection%20southern%20Indiana%20charm%20professional%20cityscape%20photography%20clean%20sky%20with%20soft%20clouds%20rich%20warm%20palette%20peaceful%20midwestern%20atmosphere&width=540&height=320&seq=evansville-hub-v1&orientation=landscape',
    icon: 'ri-map-pin-2-line',
  },
  {
    name: 'Carmel',
    county: 'Hamilton County',
    pop: '110,000+',
    href: '/carmel-life-insurance',
    tagline: "Indiana's wealthiest suburb — whole life, IUL & mortgage protection for high-income families.",
    img: 'https://readdy.ai/api/search-image?query=Carmel%20Indiana%20upscale%20suburban%20neighborhood%20with%20beautiful%20modern%20homes%20manicured%20lawns%20wide%20tree-lined%20streets%20warm%20golden%20afternoon%20light%20affluent%20midwestern%20suburb%20professional%20real%20estate%20photography%20cream%20and%20beige%20tones%20clean%20peaceful%20prosperous%20feel&width=540&height=320&seq=carmel-hub-v1&orientation=landscape',
    icon: 'ri-home-heart-line',
  },
  {
    name: 'Fishers',
    county: 'Hamilton County',
    pop: '108,000+',
    href: '/fishers-life-insurance',
    tagline: "One of Indiana's fastest-growing cities — term life & mortgage protection for young Fishers families.",
    img: 'https://readdy.ai/api/search-image?query=Fishers%20Indiana%20thriving%20suburban%20community%20new%20homes%20and%20parks%20warm%20afternoon%20sunlight%20green%20spaces%20family%20neighborhood%20modern%20suburban%20architecture%20professional%20photography%20warm%20earth%20tones%20amber%20light%20inviting%20community%20atmosphere%20clean%20sky%20bright%20welcoming&width=540&height=320&seq=fishers-hub-v1&orientation=landscape',
    icon: 'ri-sun-line',
  },
  {
    name: 'Noblesville',
    county: 'Hamilton County',
    pop: '75,000+',
    href: '/noblesville-life-insurance',
    tagline: 'Historic Hamilton County seat — growing families trust us for mortgage protection & term life.',
    img: 'https://readdy.ai/api/search-image?query=Noblesville%20Indiana%20charming%20historic%20downtown%20square%20courthouse%20brick%20buildings%20warm%20sunlight%20small%20town%20americana%20professional%20photography%20autumn%20trees%20lining%20sidewalks%20amber%20and%20cream%20warm%20tones%20peaceful%20midwestern%20historic%20city%20center%20inviting%20community%20feel&width=540&height=320&seq=noblesville-hub-v1&orientation=landscape',
    icon: 'ri-ancient-pavilion-line',
  },
  {
    name: 'Hamilton County',
    county: 'Carmel · Fishers · Noblesville',
    pop: '390,000+',
    href: '/hamilton-county-life-insurance',
    tagline: "Indiana's fastest-growing county — the complete hub for all Hamilton County life insurance needs.",
    img: 'https://readdy.ai/api/search-image?query=Hamilton%20County%20Indiana%20aerial%20suburban%20landscape%20prosperous%20growing%20community%20modern%20neighborhoods%20parks%20and%20green%20spaces%20warm%20golden%20afternoon%20light%20drone%20photography%20feel%20clean%20organized%20thriving%20suburbs%20warm%20amber%20and%20earth%20tones%20expansive%20view%20of%20flourishing%20midwestern%20community&width=540&height=320&seq=hamiltoncounty-hub-v1&orientation=landscape',
    icon: 'ri-map-2-line',
  },
];

export default function CitiesWeServeHub() {
  return (
    <section id="cities-we-serve" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section header */}
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#1A3A52]/8 text-[#1A3A52] text-[11px] font-bold uppercase tracking-widest rounded-full mb-5 border border-[#1A3A52]/15">
            <i className="ri-map-pin-fill text-[12px] text-[#D97642]"></i>
            Indiana Cities We Serve
          </span>
          <h2 className="text-[30px] md:text-[40px] font-bold text-[#1A3A52] leading-[1.15] mb-4">
            Life Insurance Coverage<br className="hidden md:block" /> Across Indiana
          </h2>
          <p className="text-[16px] text-gray-500 max-w-[560px] mx-auto leading-[1.75]">
            Dedicated local specialists in every major Indiana city — compare 20+ A-rated carriers and get personalized coverage for your community.
          </p>
        </div>

        {/* Featured — Indianapolis wide card */}
        <Link
          to={FEATURED_CITY.href}
          className="group relative block w-full rounded-2xl overflow-hidden mb-5 cursor-pointer"
          style={{ minHeight: '280px' }}
        >
          <img
            src={FEATURED_CITY.img}
            alt="Life insurance in Indianapolis, Indiana"
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            width={800}
            height={500}
            loading="eager"
            decoding="async"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0F2030]/85 via-[#1A3A52]/60 to-[#1A3A52]/20"></div>
          <div className="relative z-10 flex flex-col justify-end p-8 md:p-10 h-full" style={{ minHeight: '280px' }}>
            <div className="inline-flex items-center gap-2 bg-[#D97642] text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4 w-fit">
              <i className="ri-star-fill text-[10px]"></i>
              {FEATURED_CITY.badge}
            </div>
            <h3 className="text-[26px] md:text-[34px] font-bold text-white mb-3 leading-tight">
              Life Insurance in{' '}
              <strong className="text-[#F2A06A]">Indianapolis</strong>
            </h3>
            <p className="text-[14px] md:text-[15px] text-white/80 max-w-[520px] leading-[1.65] mb-5">
              {FEATURED_CITY.tagline}
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <span className="text-[11px] bg-white/15 border border-white/25 text-white font-semibold px-3 py-1 rounded-full">
                <i className="ri-user-line mr-1.5"></i>
                {FEATURED_CITY.pop} residents
              </span>
              <span className="text-[11px] bg-white/15 border border-white/25 text-white font-semibold px-3 py-1 rounded-full">
                <i className="ri-map-pin-line mr-1.5"></i>
                {FEATURED_CITY.county}
              </span>
              <span className="flex items-center gap-1.5 text-[#F2A06A] font-bold text-[13px] group-hover:gap-3 transition-all">
                View Indianapolis Rates <i className="ri-arrow-right-line text-[15px]"></i>
              </span>
            </div>
          </div>
        </Link>

        {/* 7-city grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-10">
          {CITIES.map((city) => (
            <Link
              key={city.name}
              to={city.href}
              className="group relative block rounded-xl overflow-hidden cursor-pointer"
              style={{ minHeight: '220px' }}
            >
              {/* Background image */}
              <img
                src={city.img}
                alt={`Life insurance in ${city.name}, ${city.county}`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                width={400}
                height={280}
                loading="lazy"
                decoding="async"
              />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D1E2C]/90 via-[#1A3A52]/50 to-transparent group-hover:from-[#0D1E2C]/95 transition-all duration-300"></div>

              {/* Content */}
              <div className="relative z-10 flex flex-col justify-end p-5 h-full" style={{ minHeight: '220px' }}>
                {/* County badge */}
                <span className="inline-flex items-center gap-1 bg-white/15 border border-white/20 text-white/80 text-[9px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full mb-2.5 w-fit">
                  <i className="ri-map-pin-line text-[#D97642] text-[9px]"></i>
                  {city.county}
                </span>

                <h3 className="text-[18px] font-bold text-white mb-1 leading-tight group-hover:text-[#F2A06A] transition-colors">
                  {city.name}
                </h3>
                <p className="text-[11px] text-white/70 leading-[1.55] mb-3 line-clamp-2">
                  {city.tagline}
                </p>

                <div className="flex items-center justify-between">
                  <span className="text-[10px] text-white/60 font-medium">
                    <i className="ri-user-line mr-1"></i>
                    {city.pop}
                  </span>
                  <span className="flex items-center gap-1 text-[#F2A06A] text-[11px] font-bold group-hover:gap-2 transition-all">
                    View Rates <i className="ri-arrow-right-line text-[12px]"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Statewide CTA strip */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-5 bg-[#F9F5F1] border border-[#E8DDD5] rounded-2xl px-7 py-6">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 flex items-center justify-center bg-[#D97642]/15 rounded-xl shrink-0">
              <i className="ri-map-2-fill text-[#D97642] text-[22px]"></i>
            </div>
            <div>
              <p className="text-[15px] font-bold text-[#1A3A52] mb-0.5">Serving All 92 Indiana Counties</p>
              <p className="text-[13px] text-gray-500 leading-[1.6]">
                Phone &amp; video consultations statewide — no matter where you are in Indiana, we&apos;ll find you the right coverage.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <Link
              to="/life-insurance-indiana"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#1A3A52] hover:bg-[#0F2A3F] text-white text-[13px] font-semibold rounded-lg transition-colors whitespace-nowrap"
            >
              <i className="ri-global-line text-[15px]"></i>
              Statewide Coverage
            </Link>
            <Link
              to="/service-areas"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-[#D97642]/40 text-[#D97642] text-[13px] font-semibold rounded-lg hover:bg-[#FFF8F4] transition-colors whitespace-nowrap"
            >
              All Service Areas
              <i className="ri-arrow-right-line text-[14px]"></i>
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}
